import useBreakpoint from "../../hooks/useBreakpoint";

const BAND_INDEX = { phone: 0, tablet: 1, laptop: 2, wide: 3 };
// A breakpoint name marks the START of a band: sm → tablet, md → (tablet, 900+), lg → laptop, xl → wide.
const START_BAND = { sm: 1, md: 1, lg: 2, xl: 3 };

/**
 * <Show above="lg"> … </Show>  renders its children only from that breakpoint up.
 * <Show below="md"> … </Show>  renders them only below it.
 *
 * For the RARE cases where markup must differ between phone and laptop (table → card list,
 * dialog → sheet). Everything that is only layout belongs in CSS (`above()` / `below()` mixins
 * from `src/styles/_fontaine-breakpoints.scss`).
 *
 * @param {{ above?: "sm"|"md"|"lg"|"xl", below?: "sm"|"md"|"lg"|"xl", children?: import("react").ReactNode }} props
 */
export default function Show({ above, below, children }) {
  const { band } = useBreakpoint();
  const idx = BAND_INDEX[band];
  if (above && idx < START_BAND[above]) return null;
  if (below && idx >= START_BAND[below]) return null;
  return children ?? null;
}
